import "./DlaylAlkhayrat.css";
import { useEffect, useState } from "react";
import arrDaysText from "./dlaylAlkhayratData";
const img9 = require("../../imgs/dlaylSections/img109.jpg");
const DlaylAlkhayrat = () => {
    const [dayNum, setDayNum] = useState(0);
    const [dayText, setDayText] = useState(arrDaysText[0]);
    // useState(arrDaysText);
    //-------------------------------------------------
    useEffect(() => {
        setDayNum(0);
        setDayText(arrDaysText[0]);
    }, []);
    //-------------------------------------------------
    const chooseDay = (num) => {
        return () => {
            setDayNum(num);
            setDayText(arrDaysText[num]);
            console.log("reham dayNum = ", num);
        };
    };
    //-------------------------------------------------
    return (
        <div className="DlaylAlkhayrat">
            <div className="text_dlayl_hizb1 text_dlayl">
                <h1>من كتاب دﻻﺋـــــﻞ اﻟﺨﻴـــــــﺮات </h1>
                <div>
                    <img className="dlaylImg" src={img9} />
                </div>
                <div>
                    <div>

                        <div className="btns_dlayl">
                            <button className="btn_dlayl" onClick={chooseDay(0)}>
                                حزب يوم الأحد
                            </button>
                            <button className="btn_dlayl" onClick={chooseDay(1)}>
                                حزب يوم الاثنين
                            </button>
                            <button className="btn_dlayl" onClick={chooseDay(2)}>
                                حزب يوم الثلاثاء
                            </button>
                            <button className="btn_dlayl" onClick={chooseDay(3)}>
                                حزب يوم ألأربعاء
                            </button>
                            <button className="btn_dlayl" onClick={chooseDay(4)}>
                                حزب يوم الخميس
                            </button>
                            <button className="btn_dlayl" onClick={chooseDay(5)}>
                                حزب يوم الجمعه
                            </button>
                            <button className="btn_dlayl" onClick={chooseDay(6)}>
                                حزب يوم السبت
                            </button>
                        </div>
                    </div>
                </div>
                <hr />
                <div>
                    <hr />

                    {dayNum < 8 ? (
                        <div className="text_dlayl_hizb " style={{ background: dayText[0] }}>
                            <h1>{dayText[1]}</h1>

                            {dayText[2] && dayText[2] !== "" ? (
                                <>
                                    <p>{dayText[2]}</p>
                                    <hr />
                                </>
                            ) : (
                                ""
                            )}

                            {dayText[3] && dayText[3] !== "" ? (
                                <>
                                    <p>{dayText[3]}</p>
                                    <hr />
                                </>
                            ) : (
                                ""
                            )}

                            {dayText[4] && dayText[4] !== "" ? (
                                <>
                                    <p>{dayText[4]}</p>
                                    <hr />
                                </>
                            ) : (
                                ""
                            )}

                            {dayText[5] && dayText[5] !== "" ? (
                                <>
                                    <p>{dayText[5]}</p>
                                    <hr />
                                </>
                            ) : (
                                ""
                            )}

                            {dayText[6] && dayText[6] !== "" ? (
                                <>
                                    <p>{dayText[6]}</p>
                                    <hr />
                                </>
                            ) : (
                                ""
                            )}

                            {dayText[7] && dayText[7] !== "" ? (
                                <>
                                    <p>{dayText[7]}</p>
                                    <hr />
                                </>
                            ) : (
                                ""
                            )}


                            {(dayText[8] && dayText[8] !== '') ? (
                                <><p>{dayText[8]}</p><hr /></>
                            ) : (
                                ""
                            )}

                            {(dayText[9] && dayText[9] !== '') ? (
                                <><p>{dayText[9]}</p><hr /></>
                            ) : (
                                ""
                            )}

                            {(dayText[10] && dayText[10] !== '') ? (
                                <><p>{dayText[10]}</p><hr /></>
                            ) : (
                                ""
                            )}
                        </div>
                    ) : (
                        "REHAM DIDn't add it Yet"
                    )}
                    <hr />
                    <div className="text_dlayl_hizb text_dlayl">
                    </div>
                </div>
            </div>
            <hr />
            <div className="text_dlayl">
                <h2>نبذه عن</h2>
                <h2>دﻻﺋـــــﻞ اﻟﺨﻴـــــــﺮات</h2>
                <p>
                    هو كتاب في الصلاة على النبي محمد صلى الله عليه وسلم، ألفه الإمام محمد
                    بن سيف الدين الأرموي الشافعي (ت 692 هـ)، ويعتبر من أشهر الكتب في هذا
                    الموضوع. يحتوي الكتاب على مجموعة من الصلوات والأدعية التي يمكن
                    للمسلمين قراءتها والتضرع بها إلى الله تعالى، مع التركيز على الصلاة على
                    النبي محمد صلى الله عليه وسلم.
                </p>
                <p>
                    يبدأ الكتاب بمقدمة تتحدث عن فضل الصلاة على النبي وأهميتها في حياة
                    المسلم، ثم ينتقل إلى عرض مجموعة من الصلوات المختلفة التي يمكن قراءتها
                    في أوقات مختلفة، مثل الصلاة على النبي في الصباح والمساء، وفي الأوقات
                    الصعبة، وعند الحاجة إلى الشفاء والرزق.
                </p>
                <p>
                    يتميز كتاب دﻻﺋـــــﻞ اﻟﺨﻴـــــــﺮات بأسلوبه السلس والواضح، مما يجعله
                    سهل القراءة والفهم. كما أنه يحتوي على تفسيرات لبعض الأحاديث النبوية
                    التي تتعلق بالصلاة على النبي، مما يزيد من فهم القارئ لأهمية هذا العمل.
                </p>
                <p>
                    يعتبر كتاب دﻻﺋـــــﻞ اﻟﺨﻴـــــــﺮات من الكتب المهمة في التراث
                    الإسلامي، ويستخدمه الكثير من المسلمين في حياتهم اليومية كوسيلة للتقرب
                    إلى الله وزيادة محبتهم للنبي محمد صلى الله عليه وسلم. كما أنه يعتبر
                    مرجعاً هاماً للعلماء والباحثين في مجال الفقه والحديث.
                </p>
                <p>
                    في الختام، يمكن القول أن كتاب دﻻﺋـــــﻞ اﻟﺨﻴـــــــﺮات هو كتاب قيم
                    ومفيد لكل مسلم، حيث يقدم مجموعة من الأدعية والصلوات التي تساعد على
                    تعزيز العلاقة بين المسلم وربه، وزيادة محبتهم للنبي محمد صلى الله عليه
                    وسلم. ينصح بقراءته والاستفادة منه في الحياة اليومية.
                </p>
            </div>
        </div >
    );
};
//-------------------------------------------------
export default DlaylAlkhayrat;
